/**
 * Initialize screen tabs store data with an empty array
 */
export var initializeNoScreenTab = function initializeNoScreenTab() {
  return function (_ref) {
    var setState = _ref.setState;
    setState({
      screenTabs: []
    });
  };
};